import { useState, useEffect } from 'react';

export type AuthMethod = 'azure_ad' | 'local' | 'both';

export interface AuthMethodResponse {
  method: AuthMethod;
  azureAdEnabled: boolean;
  localEnabled: boolean;
}

export function useAuthMethod() {
  const [method, setMethod] = useState<AuthMethod>('azure_ad');
  const [azureAdEnabled, setAzureAdEnabled] = useState(true);
  const [localEnabled, setLocalEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const base = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');
    fetch(`${base}/auth/method`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json() as Promise<AuthMethodResponse>;
      })
      .then((data) => {
        setMethod(data.method || 'azure_ad');
        setAzureAdEnabled(data.azureAdEnabled !== false);
        setLocalEnabled(!!data.localEnabled);
      })
      .catch((e: Error) => {
        setError(e.message);
        setMethod('azure_ad');
        setAzureAdEnabled(true);
        setLocalEnabled(false);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { method, azureAdEnabled, localEnabled, isLoading, error };
}
